import CompanyTimeRegistration from './CompanyTimeRegistration';

export default CompanyTimeRegistration;
